import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const MailingsSettings = lazyWithRetry(() => import(/* webpackChunkName: "stamps" */'../../component/MailingsSettings'))

const MailingsConfigPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<MailingsSettings />
		</Suspense>
	)
})

MailingsConfigPage.displayName = 'MailingsConfigPage'
export default MailingsConfigPage

